export type GroupCallHistoryUserId = number;

export interface GroupCallHistoryParticipant {
    readonly userId: GroupCallHistoryUserId | null;
    readonly joinedAt: string;
    readonly leftAt: string | null;
    readonly publishedVideo: boolean;
    readonly publishedScreen: boolean;
}

export interface GroupCallHistorySession {
    readonly sessionId: string;
    readonly roomId: string;
    readonly intent: 'audio' | 'video';
    readonly startedAt: string;
    readonly endedAt: string | null;
    readonly startedByUserId: GroupCallHistoryUserId | null;
    readonly peakParticipants: number;
    readonly participants: readonly GroupCallHistoryParticipant[];
}

export interface GroupCallHistoryQuery {
    readonly roomId?: string;
    readonly page?: number;
    readonly size?: number;
}

export interface GroupCallHistoryPage {
    readonly sessions: readonly GroupCallHistorySession[];
    readonly totalCount: number;
}

export const parseTotalCount = (header: string | null | undefined, fallback: number): number => {
    if (!header) {
        return fallback;
    }
    const parsed = Number.parseInt(header, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
};
